<template>
  <div class="app-main-content">
    <div
      v-show="showMainList"
      class="main-content"
      type="primary"
    >
      <div style="height: auto;width: 100%;" class="cargo-advance-search quotation-client-search">
        <div class="cargo-advance-search-header">
          <el-select
            v-model="category"
            no="category"
            style="margin-right: 10px;"
          >
            <el-option
              v-for="(item,index) in categories"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button no="toQuery" type="primary" @click="toQuery">
            {{ $t('Pricing.Query') }}
          </el-button>
          <el-button no="onDelete" :disabled="selectedCount === 0" type="danger" @click="onDelete()">{{ $t('Pricing.Delete') }}</el-button>
        </div>
      </div>
    </div>
    <div class="grid-view">
      <div class="main-content">
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="221701"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { getLoading } from '@/utils/utilBaseElement'
import { getMailSubscribes, deleteMailSubscribes } from '@/api/price/mailSubscribe'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TenantUtil } from '@/class/cargo/model/utils/TenantUtil'

export default {
  name: 'SubscribeList',
  components: {},
  props: {
    subscribeName: { type: String, required: true }
  },
  data() {
    return {
      URL,
      gridParams: {},
      gridApi: null,
      showDetail: false,
      tenantUtil: null,
      fullscreenLoading: null,
      rowData: [],
      selectedCount: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onSelectionChanged: event => {
          this.selectedCount = event.api.getSelectedRows().length
        }
      },
      category: 'Office',
      categories: [
        { label: this.$t('Pricing.Branch'), value: 'Office' },
        { label: 'Tenant', value: 'Tenant' }
      ],
      columnDefs: [
        {
          headerName: ' ', checkboxSelection: true, maxWidth: 40,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Pricing.IsActive'), field: 'active', colId: 'active', flex: 1,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.Subscriber'), field: 'subscriberName', colId: 'subscriberName', flex: 1
        },
        {
          headerName: this.$t('Pricing.Email'), field: 'mail', colId: 'mail', flex: 1
        },
        {
          headerName: this.$t('Pricing.SubscribeCondition'), field: 'shape', colId: 'shape', flex: 1,
          valueFormatter: (params) => {
            return this.shapeLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('Pricing.SubscribeFromTenant'), field: 'point', colId: 'point', flex: 1,
          hide: true, suppressColumnsToolPanel: true,
          valueFormatter: (params) => {
            return this.pointLabelFunc(params.data)
          }
        }
      ]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.init()
    },
    category: function(val) {
      this.rowData = []
      this.selectedCount = 0
      this.gridOptions.columnApi.setColumnVisible('point', val === 'Tenant')
    }
  },
  beforeMount() {
    this.init()
  },
  methods: {
    async init() {
      this.tenantUtil = await TenantUtil.getInstance()
    },
    toAdvancedQuery(data) {
      this.proxy = data
      this.toQuery()
    },
    toQuery() {
      this.fullscreenLoading = getLoading()
      const tenantId = this.$store.getters.tenantId
      const params = {
        tenantId: this.category === 'Office' ? tenantId : -1,
        name: this.subscribeName,
        category: this.category,
        shape: '',
        point: this.category === 'Office' ? '' : tenantId
      }
      getMailSubscribes(params).then((res) => {
        this.loadingEnd()
        this.rowData = res.data
        if (this.rowData && this.rowData.length === 0) {
          this.$message.warning(this.$t('Pricing.NoRecord'))
          return
        }
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.selectedCount = 0
      this.fullscreenLoading.close()
    },
    onDelete() {
      const selectedRows = this.getSelectedRowsCp()
      if (selectedRows === null) {
        return
      }
      this.$confirm(this.$t('Pricing.IsDeleteRecord'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        this.fullscreenLoading = getLoading()
        deleteMailSubscribes(uuids).then(res => {
          this.$message.success(this.$t('Pricing.HasDeleted'))
          this.gridOptions.api.updateRowData({ remove: selectedRows })
        }).finally(() => {
          this.loadingEnd()
        })
      })
    },
    // 获取勾选数据
    getSelectedRowsCp() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      return selectedRows
    },
    getSelectUuids(selectedRows) {
      const uuids = []
      selectedRows.forEach(item => {
        uuids.push(item.uuid)
      })
      return uuids
    },
    shapeLabelFunc(item) {
      if (item && item.shape) {
        let outline = item.shape
        outline = outline.replace(':,', ':')
        outline = outline.replace(',;', ';')
        if (outline.substr(outline.length - 1, 1) === ',') {
          outline = outline.substr(0, outline.length - 1)
        }
        return outline
      }
      return null
    },
    pointLabelFunc(data) {
      if (data.category === 'Tenant') {
        const tenantId = Number(data.remarks)
        return this.tenantUtil.getTenantNameById(tenantId)
      }
      return ''
    }
  }
}
</script>

<style scoped>

</style>
